import React from "react";
import "./dashboard.scss";
import { Select } from "antd";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";

const Box = ({
  text,
  number,
  icon,
  mainClassName,
  textClassName,
  numberClassName,
  reverse,
  filter,
  setFilter,
}) => {
  const filterOptions = [
    { label: "This Week", value: "This Week" },
    { label: "This Month", value: "This Month" },
    { label: "This Year", value: "This Year" },
  ];

  const handleFilterChange = (filterValue) => {
    setFilter(filterValue);

    let timePeriod;
    switch (filterValue) {
      case "This Week":
        timePeriod = "last_week";
        break;
      case "This Month":
        timePeriod = "last_month";
        break;
      case "This Year":
        timePeriod = "last_year";
        break;
      default:
        timePeriod = "";
    }
  };

  return (
    <div className={mainClassName}>
      <div className="h-full w-full flex justify-between gap-2 sm:gap-3">
        <div
          className={`w-full flex ${reverse ? "flex-col-reverse justify-between" : "flex-col"
            }`}
        >
          <span className={textClassName}>{text}</span>
          <div className="w-full flex items-center justify-between">
            <span className={`${numberClassName} sm:text-[28px]`}>{number}</span>
            {filter && (
              <div className="relative">
                <Select
                  value={filter}
                  className={
                    "rounded-[6px] text-[14px] font-[500] font-poppins text-black outline-none h-[33px]"
                  }
                  suffixIcon={<DownArrow />}
                  options={filterOptions}
                  defaultValue={filter}
                  onChange={handleFilterChange}
                  dropdownMatchSelectWidth={false}
                  style={{ width: "fit-content", minWidth: "120px" }}
                />
              </div>
            )}
          </div>
        </div>
        {icon ? (
          <div className="hidden xs:flex items-center justify-center h-full">
            <div className="w-[48px] h-[48px] md:w-[60px] md:h-[60px] rounded-full bg-white flex items-center justify-center">
              <img src={icon} alt="icon" />
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Box;
